<template>
  <div>
    <el-input
      maxLength="6"
      type="text"
      :size="size"
      :disabled="disabled"
      @change="changeHandle"
      @input="inputHandle"
      v-model="val"
    >
      <div slot="suffix" :class="['getMsg', sending ? 'sending' : '']" @click="getMsg">
        <span>{{ btnText }}</span>
      </div>
    </el-input>

  </div>
</template>

<script>
import { sendCaptchaApi } from "@/util/api";

export default {
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: undefined,
    tel: String,
    disabled: false,
    size: {
      type: String,
      default: "small",
    },
  },
  data() {
    return {
      val: null,
      count: 60,
      sending: false,
      timeInterval: null,
      inputValue: "",
      btnText: "验证码",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function (value) {
        this.val = value;
      },
    },
  },
  methods: {
    changeHandle(v) {
      this.$emit("change", this.val);
    },
    inputHandle(v) {
      this.$emit("msgCodeValue", v);
      this.$emit("input", this.val);
    },
    checkPhone() {
      if (!this.tel) {
        return false;
      } else {
        var p = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
        if (!p.test(this.tel)) {
          return false;
        }
      }
      return true;
    },
    getMsg() {
      if (!this.checkPhone()) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      let param = {
        phone: this.tel,
      };
      if (this.sending) return;
      this.sending = true;
      sendCaptchaApi(param).then((res) => {
        if (res.msgCode == 200) {
          console.log(res.responseData);
          this.$message.success("发送成功，请注意查收");

          this.btnText = this.count + "s重发";
          this.timeInterval = setInterval(() => {
            this.count--;
            this.btnText = this.count + "s重发";
          }, 1000);
          setTimeout(() => {
            clearInterval(this.timeInterval);
            this.btnText = "验证码";
            this.count = 60;
            this.sending = false;
          }, 60000);
        } else {
          this.$message.error(res.msg);
          this.sending = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" type="text/css">
@import "src/common/common";

</style>



// WEBPACK FOOTER //
// src/components/business/MsgCodeInput.vue